import React, { useState } from "react";
import { useMenuContext } from "../store/order_context";

const Menu = (props) => {
    const { setMainCategoryID, activeMenu, setActiveMenu, setMainCategoryName } = useMenuContext();
    
    const handleDivClick = (id) => {
        setActiveMenu(id);
    };

    return (
        <li
            onClick={() => {
                setMainCategoryID(props.menu_id);
                setMainCategoryName(props.menu_name);
                handleDivClick(props.menu_id);
            }}
            key={props.menu_id}
            className={activeMenu === props.menu_id ? 'active' : ''}
        >
            <a>{props.menu_name}</a>
        </li>
    );
};

export default Menu;